export default __webpack_public_path__ + "static/media/Mini.d9c8f93f.png";